export default "__VITE_ASSET__8e18ec00__"